
// Custom Collection mascot image animation JS Start

document.addEventListener("DOMContentLoaded", function () {
  const mascot = document.querySelector(".race-mascot");
  if (!mascot) return;

  setTimeout(() => {
    mascot.classList.add("is-visible");

    // Start continuous idle movement after roll finishes
    setTimeout(() => {
      mascot.classList.add("idle");
    }, 900);

  }, 300);
});

// Custom Collection mascot image animation JS End